import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

// Remove the old default CSS and add your custom compiled CSS
// Note: Ensure your Live Sass Compiler is running and generating 'main.css'
import './styles/main.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
